module.exports = __webpack_public_path__ + "static/media/30-9.222b6421.mp3";